import { AllowedFileTypes } from '../types/programModulesAndContents';

interface WithId {
  id: number;
}

export const LOCAL_FORM_ITEM_ID = 0;

export const filterByLocalFormId = ({ id }: WithId) =>
  LOCAL_FORM_ITEM_ID === id;

export const filterByRemoteFormId = ({ id }: WithId) =>
  LOCAL_FORM_ITEM_ID !== id;

export const EMPTY_CONTENT = {
  contentId: LOCAL_FORM_ITEM_ID,
  title: '',
  order: 0,
  type: AllowedFileTypes.Video,
  directory: '',
  instructorId: 0,
  neutralThumb: {
    preview: '',
    name: '',
    file: null,
  },
  femaleThumb: {
    preview: '',
    name: '',
    file: null,
  },
  maleThumb: {
    preview: '',
    name: '',
    file: null,
  },
  tags: [],
  description: '',
  file: {
    fileUrl: '',
    fileName: '',
  },
};

export const EMPTY_MODULE = {
  moduleId: LOCAL_FORM_ITEM_ID,
  title: '',
  description: null,
  order: null,
  contents: [EMPTY_CONTENT],
};

export const EMPTY_PROGRAM = {
  modules: [EMPTY_MODULE],
};

export const createEmptyContentWithInstructor = (instructorId: number) => ({
  ...EMPTY_CONTENT,
  instructorId,
});

export const createEmptyModuleWithInstructor = (instructorId: number) => ({
  ...EMPTY_MODULE,
  contents: [createEmptyContentWithInstructor(instructorId)],
});

export const createEmptyProgramWithInstructor = (instructorId: number) => ({
  ...EMPTY_PROGRAM,
  modules: [createEmptyModuleWithInstructor(instructorId)],
});
